import { useCallback, useRef, useState } from "react";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { downloadExport } from "@/lib/exportDownload";

// Export s průběhem (217): během stahování je tlačítko zakázané a ukazuje se hláška
// „Připravuji…", opakované kliknutí nespustí další export. Zámek drží useRef (jako
// useSubmitGuard) — druhý klik ve stejném tiku neprojde; `busy` je klíč běžícího
// exportu jen pro zobrazení (spinner u správného tlačítka).
//
//   const { busy, run } = useExportDownload();
//   <Button disabled={!!busy} onClick={() => run("xlsx", "/api/…?fmt=xlsx", "soubor.xlsx")}>
export const EXPORT_TIMEOUT_MSG = "Export trval příliš dlouho. Zkuste menší rozsah (kratší období, bez fotek).";

export function exportErrorMessage(err) {
  const st = err?.response?.status;
  if (st === 504 || st === 524) return EXPORT_TIMEOUT_MSG;   // proxy / Cloudflare utnula dlouhý export
  return apiError(err);
}

export function useExportDownload() {
  const [busy, setBusy] = useState(null);
  const lock = useRef(false);

  const run = useCallback(async (key, path, filename, label = "Připravuji soubor…") => {
    if (lock.current) return false;
    lock.current = true;
    setBusy(key);
    const id = toast.loading(label);
    try {
      await downloadExport(path, filename);
      toast.success("Hotovo, soubor se stahuje.", { id, duration: 2500 });
      return true;
    } catch (e) {
      toast.error(exportErrorMessage(e), { id });
      return false;
    } finally {
      lock.current = false;
      setBusy(null);
    }
  }, []);

  return { busy, run };
}
